module.exports = __webpack_public_path__ + "static/media/kid_friendly-grey.8f5aeb68.png";